/* eslint-disable no-shadow */
import DateTimeHandler from "@/services/common/date-time/DateTimeHandlerService";
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { http } from "@/api/index";
import { GetErrorMessage } from "@/constants/errors-http/HTTPHandler";
import {
	OPEN_AUDIO_DIALOG,
	CLOSE_AUDIO_DIALOG,
	GET_AUDIO_LIST,
	GET_AUDIO_LIST_ERROR,
	GET_AUDIO_LIST_SUCCESS,
} from "@/stores/actions/Audio";

/**
* @summary Atribui a um Array objetos que contém o nomes do gatilho, data e id dos registros.
* @type {function}
* @param {Array[Object]} - Array do objeto contendo as informações para download e para tocar o áudio.
* @return {Array[Object]} Um array de objetos que contém Id, nome e gatilhos.
*/
const SetDataTable = (audioInfoList) =>
{
	const audioDataTable = [];

	for (let i = 0; i < audioInfoList.length; i++)
	{
		const audioInfo = {
			signalSettingId:  0,
			signalRegisterId: 0,
			name:             "",
			date:             "",
			id:               0,
		};
		audioInfo.signalSettingId = audioInfoList[i].signalSettingId;
		audioInfo.signalRegisterId = audioInfoList[i].signalRegisterId;
		audioInfo.name = audioInfoList[i].name;
		audioInfo.date = DateTimeHandler.ToLocalDateTime(audioInfoList[i].date);
		audioInfo.id = i;
		audioDataTable.push(audioInfo);
	}
	return audioDataTable;
};

const state = {
	dialog:    false,
	status:    "",
	tableData: [],
	error:     {},
};

const actions = {
	[OPEN_AUDIO_DIALOG]: ({ commit }) =>
	{
		commit(OPEN_AUDIO_DIALOG);
	},
	[CLOSE_AUDIO_DIALOG]: ({ commit }) =>
	{
		commit(CLOSE_AUDIO_DIALOG);
	},
	[GET_AUDIO_LIST]: ({ commit }, monitoringElementId) =>
	{
		commit(GET_AUDIO_LIST);
		http.get(`/Audio/${monitoringElementId}`)
			.then((resp) =>
			{
				if (resp.status !== 200)
				{
					const errorResponse = {};
					errorResponse.errorMessage = GetErrorMessage(resp.status);
					errorResponse.errorStatus = resp.status;
					commit(GET_AUDIO_LIST_ERROR, errorResponse);
				}
				else
				{
					const audioTable = SetDataTable(resp.data);
					commit(GET_AUDIO_LIST_SUCCESS, audioTable);
				}
			})
			.catch((error) =>
			{
				commit(GET_AUDIO_LIST_ERROR, error.response);
			});
	},
};

const mutations = {
	[OPEN_AUDIO_DIALOG]: (state) =>
	{
		state.dialog = true;
	},
	[CLOSE_AUDIO_DIALOG]: (state) =>
	{
		state.dialog = false;
	},
	[GET_AUDIO_LIST]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_AUDIO_LIST_SUCCESS]: (state, resp) =>
	{
		state.tableData = resp;
		state.status = FetchStatus.Error;
	},
	[GET_AUDIO_LIST_ERROR]: (state, error) =>
	{
		state.error = error;
		state.status = FetchStatus.Error;
	},
};

export default {
	state,
	actions,
	mutations,
};
